import { render } from "./AlimtalkResultsTable.vue?vue&type=template&id=1d8175ba&scoped=true"
import script from "./AlimtalkResultsTable.vue?vue&type=script&lang=js"
export * from "./AlimtalkResultsTable.vue?vue&type=script&lang=js"

import "./AlimtalkResultsTable.vue?vue&type=style&index=0&id=1d8175ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8175ba"]])

export default __exports__